export function normalizeWorkspace(record = {}) {
  const safeRecord =
    record && typeof record === "object" ? record : {};
  const photos = [];
  const seenPhotos = new Set();
  if (Array.isArray(safeRecord.photos)) {
    safeRecord.photos.forEach((photo) => {
      const value = String(photo || "").trim();
      if (!value || seenPhotos.has(value)) return;
      seenPhotos.add(value);
      photos.push(value);
    });
  }
  const name =
    safeRecord.name ||
    safeRecord.workspace_name ||
    safeRecord.booth_name ||
    safeRecord.title ||
    "";
  const workspaceCode =
    safeRecord.workspace_code ||
    safeRecord.booth_number ||
    safeRecord.code ||
    null;
  return {
    ...safeRecord,
    name,
    title: name,
    workspaceName: name,
    booth_name: safeRecord.booth_name || name,
    workspace_code: workspaceCode,
    booth_number: safeRecord.booth_number || workspaceCode,
    pricing_rules: Array.isArray(safeRecord.pricing_rules) ? safeRecord.pricing_rules : [],
    amenity_addons: Array.isArray(safeRecord.amenity_addons) ? safeRecord.amenity_addons : [],
    photos,
    booking_rules_json:
      safeRecord.booking_rules_json && typeof safeRecord.booking_rules_json === "object"
        ? safeRecord.booking_rules_json
        : {},
  };
}

export function getWorkspaceDisplayName(workspace) {
  return normalizeWorkspace(workspace).workspaceName || "Workspace";
}

export function getWorkspaceCode(workspace) {
  return normalizeWorkspace(workspace).workspace_code;
}

export function getWorkspaceLocation(workspace) {
  const normalized = normalizeWorkspace(workspace);
  return [
    normalized?.salon?.address,
    normalized?.salon?.city,
    normalized?.salon?.province,
  ]
    .filter(Boolean)
    .join(", ");
}

export function getWorkspacePublicIdentifier(workspace) {
  const normalized = normalizeWorkspace(workspace);
  return normalized.public_slug || normalized.id;
}

export function getWorkspaceListingPath(workspace) {
  return `/workspaces/${getWorkspacePublicIdentifier(workspace)}`;
}

export function getWorkspaceCheckoutPath(workspace) {
  return `/checkout/${getWorkspacePublicIdentifier(workspace)}`;
}

export function formatWorkspaceMoney(value, currency = "CAD") {
  const amount = Number(value ?? 0);
  if (!Number.isFinite(amount)) {
    return "$0.00";
  }
  try {
    return new Intl.NumberFormat("en-CA", {
      style: "currency",
      currency: String(currency || "CAD").toUpperCase(),
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `$${amount.toFixed(2)}`;
  }
}

export function formatWorkspaceDateTime(value) {
  if (!value) return "TBD";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "TBD";
  return date.toLocaleString();
}

export function titleCaseLabel(value, fallback = "Not set") {
  const raw = String(value || "").trim();
  if (!raw) return fallback;
  return raw
    .replace(/_/g, " ")
    .split(" ")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export function statusPillClasses(tone = "neutral") {
  if (tone === "success") return "bg-emerald-50 text-emerald-700 border-emerald-200";
  if (tone === "danger") return "bg-rose-50 text-rose-700 border-rose-200";
  if (tone === "accent") return "bg-sky-50 text-sky-700 border-sky-200";
  if (tone === "warning") return "bg-amber-50 text-amber-700 border-amber-200";
  return "bg-slate-100 text-slate-700 border-slate-200";
}
